import { SusunanKeluargaResponse } from "../../../../models/SusunanKeluarga";
import { getApiInstance } from "../../../api";
import mutationWrapper from "../../mutationWrapper";
import ApiClient from "../../../apiClient";

export async function susunanKeluarga(
  KELUARGA_ID: number
): Promise<SusunanKeluargaResponse> {
  const res = await ApiClient.get(
    `/Keluarga?SUSUNAN_KELUARGA_ID=${KELUARGA_ID}`
  );
  return res.data[0];
}

export const useFetchSusunanKeluarga = mutationWrapper(susunanKeluarga);
